
<component
  :is="as"
  :type="type"
  :class="['icon-button', { hidden }]"
  :disabled="disabled || loading"
  v-bind="$attrs"
  v-on="$listeners"
  v-tooltip="{ content: tooltip, delay: { show: 1500, hide: 100 }, placement: 'bottom' }"
>
  <icon
    class="icon"
    :name="icon"
    :style="{ 'font-size': `${size}px` }"
  />

  <span v-if="alert" class="alert" />

  <span v-show="loading" class="spinner-container">
    <span class="spinner" />
  </span>
</component>
